import * as yup from "yup";

export const PASS_CODE_LENGTH = 4;

export function createPasscodeSchema({ invalidError } = {}) {
  return yup
    .string()
    .matches(new RegExp(`^[0-9]{${PASS_CODE_LENGTH}}$`), invalidError);
}
